import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./index.css";
import "./styles/variables.css";
import { AuthProvider } from "./context/AuthContext";
import router from "./router";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        gutter={10}
        containerStyle={{ top: 70 }}
        toastOptions={{
          duration: 4000,
          style: {
            fontFamily: "Inter, ui-sans-serif, sans-serif",
            fontSize: "0.84rem",
            fontWeight: 500,
            borderRadius: "10px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
            padding: "0.65rem 1rem",
            maxWidth: 360,
          },
          success: {
            iconTheme: { primary: "#1a6b3c", secondary: "#fff" },
            style: { borderColor: "#bbf7d0" },
          },
          error: {
            iconTheme: { primary: "#ef4444", secondary: "#fff" },
            style: { borderColor: "#fecaca" },
          },
        }}
      />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
